import {ProductPerformanceComponent} from "./product-performance.component";

export default ProductPerformanceComponent
